import { User } from './types';

const hasBankDetails = (user: User): boolean => {
  const bankDetails = user.bankDetails;

  return Boolean(
    user.verification?.isBankVerified ||
    (bankDetails &&
      Object.keys(bankDetails).length > 0 &&
      bankDetails.isActive !== false)
  );
};

export const isKYCCompleted = (user: User | null): boolean => {
  if (!user?.verification) {
    return false;
  }

  const { verification } = user;
  const hasAnyDocumentVerified =
    verification?.isAadhaarVerified ||
    verification?.isPanVerified ||
    verification?.isPassportVerified;

  return Boolean(
    hasAnyDocumentVerified &&
    verification?.facialVerification &&
    hasBankDetails(user)
  );
};

export const getKYCStatus = (user: User | null) => {
  if (!user?.verification) {
    return {
      isCompleted: false,
      isAadhaarVerified: false,
      isPanVerified: false,
      isPassportVerified: false,
      isFacialVerified: false,
      hasBankDetails: false,
      aadharNumber: null,
      panNumber: null,
      passportNumber: null,
      facialVerification: null,
    };
  }

  const { verification } = user;
  const hasAnyDocumentVerified =
    verification?.isAadhaarVerified ||
    verification?.isPanVerified ||
    verification?.isPassportVerified;

  const isFacialVerified = Boolean(verification?.facialVerification);
  const isBankVerified = hasBankDetails(user);
  const isCompleted = Boolean(
    hasAnyDocumentVerified && isFacialVerified && isBankVerified
  );

  return {
    isCompleted,
    isAadhaarVerified: verification?.isAadhaarVerified || false,
    isPanVerified: verification?.isPanVerified || false,
    isPassportVerified: verification?.isPassportVerified || false,
    isFacialVerified,
    hasBankDetails: isBankVerified,
    aadharNumber: verification?.aadharNumber || null,
    panNumber: verification?.panNumber || null,
    passportNumber: verification?.passportNumber || null,
    facialVerification: verification?.facialVerification || null,
  };
};
